import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import Input from '../atoms/Input'
import Button from '../atoms/Button'
import Preloader from '../atoms/Preloader'

// actions
import { loginAction } from './../../store/sessionDuck'
import { sendDataLayer } from '../../utils/functions'

import { useMediaQuery } from 'react-responsive';

function LoginForm({
  type,
  fields,
  buttonText,
  loginAction,
  autologin,
  hash
}) {
  const [document, setDocument] = useState('')
  const [emailPhone, setEmailPhone] = useState('')
  const [birthdate, setBirthdate] = useState('')
  const [code, setCode] = useState('')
  const [terms, setTerms] = useState(false)
  const [terms2, setTerms2] = useState(false) // <- independiente
  const [terms3, setTerms3] = useState(false)
  const [terms4, setTerms4] = useState(false)
  const [img, setImg] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [extraLoginPreloader, setExtraLoginPreloader] = useState(false)
  const [hasShownTerms2, setHasShownTerms2] = useState(false)

  const [errors, setErrors] = useState({
    document: false,
    emailPhone: false,
    birthdate: false,
    code: false,
    card: false,
    terms: false,
    termsData: false,
    login: false,
  })
  const [gToken, setGToken] = useState(false)
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  const clickTermsOptional = () => {
    console.log('clickTermsOptional')
  }

  // ----------- NUEVO: handler por campo (no dependemos de rel/name) -----------
  const onChangeFactory = (fieldName, fieldDef) => (e) => {
    // según el tipo/campo, actualizamos el estado correcto
    if (fieldName === 'code') {
      const max = (fieldDef?.maxlength ?? 9)
      if (e.target.value.length <= max) {
        setCode(e.target.value)
        setErrors(prev => ({ ...prev, code: false, login: false }))
      }
      return
    }

    if (fieldName === 'document') {
      const numbers = /^\d+$/
      const max = (fieldDef?.maxlength ?? 5)
      if ((numbers.test(e.target.value) || e.target.value === '') && e.target.value.length <= max) {
        setDocument(e.target.value)
        setErrors(prev => ({ ...prev, document: false }))
      }
      return
    }

    if (fieldName === 'birthdate') {
      setBirthdate(e.target.value)
      setErrors(prev => ({ ...prev, birthdate: false }))
      return
    }

    if (fieldName === 'emailPhone') {
      setEmailPhone(e.target.value)
      setErrors(prev => ({ ...prev, emailPhone: false }))
      return
    }

    if (fieldName === 'card') {
      const numbers = /^\d+$/
      if ((numbers.test(e.target.value) || e.target.value === '') && e.target.value.length < 6) {
        // Se mantiene tu comportamiento previo (actualiza document). Si quieres que actualice "card", cámbialo a setCard(e.target.value)
        setDocument(e.target.value)
        setErrors(prev => ({ ...prev, card: false }))
      }
      return
    }
    if (fieldName === 'terms') {
      clickTermsOptional()
      setTerms(e.target.checked)
      setErrors(prev => ({ ...prev, terms: false }))
      return
    }
    
    if (fieldName === 'terms2') {
      if (terms2)
      {
        setTerms2(false)
        setTerms3(false)
        setTerms4(false)
      }else{

        setTerms2(true)
        setTerms3(true)
        setTerms4(true)
      }
      return
    }

    if (fieldName === 'terms3') {
      const checked = e.target.checked
      setTerms3(checked)
      setImg(true)
      return
    }

    if (fieldName === 'terms4') {
      const checked = e.target.checked
      setTerms4(checked)
      setImg(true)
      return
    }
  }

  useEffect(() => {
    // si ambos hijos están desactivados → desactivar terms2
    if (!terms3 && !terms4) {
      setTerms2(false)
    }

    if (terms3 || terms4) {
      setTerms2(true)
    }
  }, [terms3, terms4])

  const handleLogin = async () => {
    setErrors(prev => ({ ...prev, login: false }))
    sendDataLayer({ datalayer: { event: 'button_login' }, repeat: true })
    setIsLoading(true)

    const field_code = fields.find((f) => f.field === 'code')
    const field_document = fields.find((f) => f.field === 'document')
    const field_emailPhone = fields.find((f) => f.field === 'emailPhone')
    const field_birthdate = fields.find((f) => f.field === 'birthdate')
    const field_terms = fields.find((f) => f.field === 'terms')

    if (field_code && code.length <= ((field_code?.maxlength ?? 6) - 1)) {
      setIsLoading(false)
      setErrors(prev => ({ ...prev, code: '*El código debe contener mínimo 6 dígitos.', login: true }))
      sendDataLayer({ datalayer: { event: 'error_login', text: '*El código debe contener mínimo 6 dígitos.' }, repeat: true })
      return false
    }

    if (field_document && document.length <= ((field_document?.maxlength ?? 5) - 1)) {
      setIsLoading(false)
      return false
    }

    if (field_emailPhone) {
      const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/
      const numbers = /^\d+$/
      if (emailPhone.includes('@')) {
        if (!isEmail.test(emailPhone)) {
          setIsLoading(false)
          setErrors(prev => ({ ...prev, emailPhone: 'Inserta un correo válido.' }))
          return false
        }
      } else if ((numbers.test(emailPhone) && (emailPhone.length < 10 || emailPhone.length > 10))) {
        setIsLoading(false)
        setErrors(prev => ({ ...prev, emailPhone: 'Inserta un número de celular válido.' }))
        return false
      }
    }

    if (field_birthdate && birthdate === "") {
      setIsLoading(false)
      setErrors(prev => ({ ...prev, birthdate: 'Ingresa tu fecha de nacimiento.' }))
      return false
    }

    if (field_terms && !terms) {
      setIsLoading(false)
      setErrors(prev => ({ ...prev, terms: 'Por favor marca esta casilla para continuar.', login: true, }))
      sendDataLayer({ datalayer: { event: 'error_login', text: 'He leído y acepto los ", termsText: "Términos y condiciones.' }, repeat: true })
      sendDataLayer({ datalayer: { event: 'terms', category: 'terms', action: 'clic', label: 'terms' }, repeat: false })
      return false
    }

    let captcha;

    try {
      captcha = await getCaptchaToken();
    } catch (error) {
      setIsLoading(false);
      setErrors({ ...errors, login: 'No se pudo validar el captcha. Intenta nuevamente.' });
      return false;
    }

    loginAction({
      campaignCode: process.env.REACT_APP_GLOBAL_CODE,
      type: "credentials",
      credentials: {
        code: code,
      },
      checks: {
        checkbox_1: terms,
        checkbox_2: terms2,
        checkbox_3: terms3,
        checkbox_4: terms4
      },
      actions: "none"
    }, captcha.token, captcha.version);

    setTimeout(() => {
      setExtraLoginPreloader(true)
    }, 5000)
  }

  const getCaptchaToken = () => {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) {
        reject('reCAPTCHA no cargó');
        return;
      }

      window.grecaptcha.ready(() => {
        if (isSafari) {
          window.onSubmit = function (token) {
            setGToken(token);
            resolve({ token, version: 'V2' });
          };

          window.grecaptcha.execute();
        } else {
          window.grecaptcha
            .execute(process.env.REACT_APP_RECAPTCHAKEY, { action: 'login' })
            .then((token) => {
              setGToken(token);
              resolve({ token, version: 'V3' });
            })
            .catch(reject);
        }
      });
    });
  };

  const handleLoaded = () => {
    console.log('reCAPTCHA loaded');
  };

  useEffect(() => {
    const script = window.document.createElement("script");
    script.src = isSafari
      ? "https://www.google.com/recaptcha/api.js"
      : `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHAKEY}`;
    script.async = true;
    script.defer = true;
    script.addEventListener("load", handleLoaded)
    window.document.body.appendChild(script)
  }, []);

  useEffect(() => {
    if (hash && hash !== '') {
      setIsLoading(true)
      if (!localStorage.getItem('userNotFound')) {
        console.log("Run autologin!", hash)
        loginAction({
          campaignCode: process.env.REACT_APP_GLOBAL_CODE,
          type: "autologin",
          credentials: {
            code_hash: hash
          },
          checks: {
            checkbox_1: terms,
            checkbox_2: terms2,
            checkbox_3: terms3,
            checkbox_4: terms4
          },
          actions: "none"
        }, gToken)
      }
    }
  }, [hash])

  const actionLink = (e) => {
    e.preventDefault();
    setHasShownTerms2(true)
    return
  }

  // El boton solo se habilita cuando estan los datos minimos que despues valida
  // handleLogin, para no ofrecer un CTA que de todas formas va a fallar.
  // Se recorre `fields` en vez de asumir el formulario: cada campo solo cuenta
  // si esta configurado. terms2/terms3/terms4 son opcionales (handleLogin no los
  // valida) y por eso no entran aqui.
  const findField = (name) => (fields ?? []).find((f) => f.field === name)

  const isEmailPhoneComplete = () => {
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/
    const numbers = /^\d+$/
    if (emailPhone === '') return false
    if (emailPhone.includes('@')) return isEmail.test(emailPhone)
    if (numbers.test(emailPhone)) return emailPhone.length === 10
    return true
  }

  const isFormComplete = () => {
    const field_code = findField('code')
    if (field_code && code.length < (field_code.maxlength ?? 6)) return false

    const field_document = findField('document')
    if (field_document && document.length < (field_document.maxlength ?? 5)) return false

    if (findField('emailPhone') && !isEmailPhoneComplete()) return false
    if (findField('birthdate') && birthdate === '') return false
    if (findField('terms') && !terms) return false

    return true
  }

  const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });

  return (
    <div className={`mc-login mc-login-${type}`}>
      {isSafari ? (
        <div className="g-recaptcha"
          data-sitekey={process.env.REACT_APP_RECAPCHAKEYSAFARI}
          data-callback="onSubmit"
          data-size="invisible">
        </div>
      ) : (
        <div
          className="g-recaptcha"
          data-sitekey={process.env.REACT_APP_RECAPTCHAKEY}
          data-size="invisible"
        ></div>
      )}

      {(extraLoginPreloader || autologin) &&
        <Preloader
          type="fullscreen"
          invert={true}
        />
      }

      <div className='container-login'>
        <div className='mc-login__form'>
          <h2 className='mc-login__form--title'>Que se note <br/>que tu tarjeta te<br/>acerca a ganar</h2>
          <p className='mc-login__form--subtitle'>Conoce tu objetivo y participa</p>
          {isLoading &&
            <div className='mc-login__form--overlay slow_ani'></div>
          }
          <div className='mc-login__form--fields'>
          
            {fields.map((field, index) => {
  const coercedType = field.field === 'terms' || field.field === 'terms2' || field.field === 'terms3' || field.field === 'terms4' ? 'terms' : field.field

  const value =
    field.field === 'document' ? document :
    field.field === 'birthdate' ? birthdate :
    field.field === 'terms' ? terms :
    field.field === 'terms2' ? terms2 :
    field.field === 'terms3' ? terms3 :
    field.field === 'terms4' ? terms4 :
    field.field === 'img' ? img :
    field.field === 'code' ? code :
    field.field === 'emailPhone' ? emailPhone :
    false

  const error =
    field.field === 'document' ? errors.document :
    field.field === 'birthdate' ? errors.birthdate :
    field.field === 'terms' ? errors.terms :
    field.field === 'terms2' ? errors.terms2 :
    field.field === 'terms3' ? errors.terms3 :
    field.field === 'terms4' ? errors.terms4 :
    field.field === 'code' ? errors.code :
    field.field === 'emailPhone' ? errors.emailPhone :
    false

  if ((field.field === 'terms3' || field.field === 'terms4' || field.field === 'img') && !hasShownTerms2) {
    return null
  }

  return (
    <Input
      key={index}
      type={coercedType}
      label={field.label}
      placeholder={field.placeholder}
      termsText={field.termsText}
      termsLink={field.termsLink}
      actionLink={field.action && actionLink}
      onChange={onChangeFactory(field.field, field)}
      inputByCharacter={field.separated ? field.separated : false}
      maxLength={field.maxlength}
      value={value}
      error={error}
      invalid={Boolean(error)}                         // 👈 NUEVO
      errorText={typeof error === 'string' ? error : ''} // 👈 NUEVO (mensaje)
      tooltip={field.tooltip}
      addClassName={field.addClassName}
    />
  )
})}
          </div>
          <div>
            {errors.login && <p className='error'>{errors.login}</p>}
          </div>
          
          <Button
            type="primary"
            text={buttonText}
            loading={isLoading}
            status={isFormComplete() ? 'active' : 'inactive'}
            onClick={handleLogin}
            addClassName={errors.login ? 'error_lock': ''}
          />
          <div className='card_container solo-mobile'>
            <img src={'/assets/images/tarjeta.png'} alt="" />
          </div>
        </div>
        {isDesktop ? (
          <div className='login-img-container'>
          </div>
        ) : (
          <div className='login-img-container'>
          </div>
        )}
      </div>
    </div>
  )
}

const mapState = ({ user: { token } }) => {
  return {
    token
  }
}

export default connect(mapState, { loginAction })(LoginForm)
